import React from 'react';
import { Typography, Tooltip } from '@mui/material';
import { CalendarToday, Person, SwapHoriz, Description } from '@mui/icons-material';
import { Column } from 'components/shared/TableListing/types';

import { BpfChangelogTableRow } from './types';
import { ChangeTypeChip, ChangesCell } from './cells';

export const changelogListingColumns: Column<BpfChangelogTableRow>[] = [
  {
    width: '11rem',
    header: 'Date time',
    renderKey: 'createdDateTime',
    startIcon: (
      <Tooltip arrow placement="top" title="Date when change was made">
        <CalendarToday fontSize="small" color="primary" />
      </Tooltip>
    ),
    renderCell: ({ row: { createdDateTime } }) => <Typography>{createdDateTime}</Typography>,
  },
  {
    width: '16rem',
    header: 'Change Type',
    renderKey: 'changeType',
    startIcon: (
      <Tooltip arrow placement="top" title="Type of change">
        <SwapHoriz fontSize="small" color="primary" />
      </Tooltip>
    ),
    renderCell: ({ row: { changeType } }) => <ChangeTypeChip changeType={changeType} />,
  },
  {
    width: '12rem',
    header: 'Modified By',
    renderKey: 'modifiedBy',
    startIcon: (
      <Tooltip arrow placement="top" title="Person who made changes">
        <Person fontSize="small" color="primary" />
      </Tooltip>
    ),
    renderCell: ({ row: { modifiedBy } }) => <Typography>{modifiedBy}</Typography>,
  },
  {
    header: 'Changes',
    renderKey: 'changes',
    startIcon: (
      <Tooltip arrow placement="top" title="Change details">
        <Description fontSize="small" color="primary" />
      </Tooltip>
    ),
    renderCell: ({ row: { changeType, changes } }) => <ChangesCell changeType={changeType} changes={changes} />,
  },
];
